export const FEED_SHOW_RESET = "FEED_SHOW_RESET";
export const FEED_SHOW_SET_ERROR = "FEED_SHOW_SET_ERROR";
export const FEED_SHOW_SET_RETRIEVED = "FEED_SHOW_SET_RETRIEVED";
export const FEED_SHOW_TOGGLE_LOADING = "FEED_SHOW_TOGGLE_LOADING";
